if (!customElements.get('product-card-media')) {
  class ProductCardMedia extends HTMLElement {
    constructor() {
      super();
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.activeIndex = 0;
    }

    connectedCallback() {
      this.slidesRoot = this.querySelector('[data-pcard-slides]');
      this.slideEls = this.slidesRoot ? [...this.slidesRoot.querySelectorAll('[data-pcard-slide]')] : [];
      this.prevBtn = this.querySelector('[data-pcard-prev]');
      this.nextBtn = this.querySelector('[data-pcard-next]');
      this.slideCount = this.slideEls.length;

      if (this.slideCount <= 1) return;

      this.prevBtn?.addEventListener('click', this.onPrevClick);
      this.nextBtn?.addEventListener('click', this.onNextClick);

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this);

      this.layoutSlides();
      this.setActive(0);
      this.updateButtons();

      const firstImage = this.querySelector('img');
      if (firstImage?.complete) {
        this.classList.add('is-loaded');
      } else if (firstImage) {
        firstImage.addEventListener(
          'load',
          () => {
            this.classList.add('is-loaded');
          },
          { once: true }
        );
      }
    }

    disconnectedCallback() {
      this.prevBtn?.removeEventListener('click', this.onPrevClick);
      this.nextBtn?.removeEventListener('click', this.onNextClick);
      this.resizeObserver?.disconnect();
    }

    onResize() {
      this.layoutSlides();
      this.updateTrack(false);
    }

    layoutSlides() {
      const width = this.clientWidth;
      if (!width || !this.slidesRoot) return;

      this.slideWidth = width;
      this.slidesRoot.style.width = `${width * this.slideCount}px`;

      this.slideEls.forEach((slide) => {
        slide.style.width = `${width}px`;
        slide.style.flexBasis = `${width}px`;
      });
    }

    updateTrack(animate = true) {
      if (!this.slidesRoot || !this.slideWidth) return;

      this.slidesRoot.classList.toggle('is-animating', animate);
      this.slidesRoot.style.transform = `translate3d(-${this.activeIndex * this.slideWidth}px, 0, 0)`;
    }

    onPrevClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.activeIndex <= 0) return;
      this.setActive(this.activeIndex - 1);
    }

    onNextClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.activeIndex >= this.slideCount - 1) return;
      this.setActive(this.activeIndex + 1);
    }

    updateButtons() {
      this.prevBtn?.toggleAttribute('disabled', this.activeIndex <= 0);
      this.nextBtn?.toggleAttribute('disabled', this.activeIndex >= this.slideCount - 1);
    }

    setActive(index) {
      this.activeIndex = index;

      this.slideEls.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });

      this.updateTrack(true);
      this.updateButtons();
    }
  }

  customElements.define('product-card-media', ProductCardMedia);
}
